import { render, staticRenderFns } from "./StockManagementDetail.vue?vue&type=template&id=06915386&scoped=true"
import script from "./StockManagementDetail.vue?vue&type=script&lang=js"
export * from "./StockManagementDetail.vue?vue&type=script&lang=js"
import style0 from "./StockManagementDetail.vue?vue&type=style&index=0&id=06915386&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06915386",
  null
  
)

export default component.exports